import React from 'react';

import { separator } from './Separator.less';

const Separator = () => <div className={separator} />;

export default Separator;
